import React from 'react';

import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { MILLION_USERS } from '../../../../constants/constants';

export const DetailsBarSection = () => (
  <div
    className="w-col-4 sm:w-col-8 mx-auto my-20 flex flex-row justify-between"
    data-testid="DetailsBarSection"
  >
    <div className="flex items-center sm:flex-col">
      <div className="ml-4 flex flex-col items-start sm:ml-0 sm:items-center">
        <Heading as="div" className="mb-0 sm:mb-2">
          2010
        </Heading>
        <Text variant="sm" className="font-semibold">
          Founded
        </Text>
      </div>
    </div>
    <div className="flex items-center sm:flex-col">
      <div className="ml-4 flex flex-col items-start sm:ml-0 sm:items-center">
        <Heading as="div" className="mb-0 sm:mb-2">{`${MILLION_USERS}M`}</Heading>
        <Text variant="sm" className="font-semibold">
          Registered users
        </Text>
      </div>
    </div>
    <div className="flex items-center sm:flex-col">
      <div className="ml-4 flex flex-col items-start sm:ml-0 sm:items-center">
        <Heading as="div" className="mb-0 sm:mb-2">
          #1
        </Heading>
        <Text variant="sm" className="font-semibold">
          Fishing app
        </Text>
      </div>
    </div>
  </div>
);
